import { EJStatus } from '@cims-online/shared'
import CIMSFormItem from 'components/CIMSFormItem'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import ExternalLinkEditor from 'components/ExternalLinkEditor'
import { HelpMessage } from 'utils/constants'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'
import { CreateEditEJFormItemsProps } from './types'

const Help = HelpMessage.EngineeringJudgements.EJLog

const CreateEditEJFormItems: React.VFC<CreateEditEJFormItemsProps> = ({
  statusId,
  hideCustomFields,
  loading,
  quickLinks,
}) => {
  return (
    <>
      <CIMSFormItem label="Pay Items" name="payItems" help={Help.PayItems}>
        <PayItemSelect mode="multiple" />
      </CIMSFormItem>
      {!hideCustomFields && (
        <CustomFieldEditor
          hideBooleans={!!statusId}
          alreadyDisabled={
            statusId === EJStatus.Closed.id
              ? { why: 'invalid status', statusName: EJStatus.Closed.name }
              : false
          }
        />
      )}
      <ExternalLinkEditor
        disabled={statusId === EJStatus.Closed.id}
        quickLinkOptions={{
          loading: loading ?? undefined,
          quickLinks: quickLinks ?? undefined,
        }}
      />
    </>
  )
}

export default CreateEditEJFormItems
